import React from 'react';
import R from 'ramda';
import { connect } from 'react-redux';
import { COMPLETE_STEP } from 'introduction/introductionActions';
import { SHOW_CANCEL_SUBMISSION_DIALOG } from 'submission/submissionActions';
import { getLoading } from 'common/stepReducerUtil';
import { getStep } from 'common/selectors';
import * as steps from 'common/steps';
import LoadingPanel from 'general-components/LoadingPanel';
import StepPanelButtonBar from 'general-components/StepPanelButtonBar';
import styles from './Introduction.css';

const IntroductionStepPanel = ({ loading, onCancel, onNext }) =>
  loading
    ? <LoadingPanel />
    : <div className={styles.stepPanel}>
        <h1>Introduction</h1>
        <p>
          You will be guided through a simple upload process for your ETD on the
          following pages. You can move between steps as you see fit, and the
          form will remember your submission if you go away and come back later.
        </p>
        <p>
          You will be offered opt-in choices for the two discovery programs
          offered via OpenDissertations.org, enter metadata, and then upload
          your files.
        </p>
        <p>
          If you have any problems or issues, please email:{' '}
          <a
            href="mailto:opendissertations@bibliolabs.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            opendissertations@bibliolabs.com
          </a>
        </p>
        <StepPanelButtonBar onNext={onNext} onCancel={onCancel} />
      </div>;

const mapState = state =>
  R.pipe(
    getStep(steps.INTRODUCTION),
    R.applySpec({
      loading: getLoading,
    }),
  );

const mapDispatch = dispatch => ({
  onCancel: () => dispatch({ type: SHOW_CANCEL_SUBMISSION_DIALOG, show: true }),
  onNext: () => dispatch({ type: COMPLETE_STEP }),
});

export default connect(mapState, mapDispatch)(IntroductionStepPanel);



// WEBPACK FOOTER //
// ./src/introduction/components/Introduction.js